/* reservation.js — Soleil du Sud
   1) Réserve le stock à chaque changement de panier (backend).
   2) Compteur élégant dont la couleur glisse du jaune vers l'orangé/corail
      à mesure que le temps s'écoule (progressif, doux).
   Transparent : n'empêche jamais l'ajout au panier (fail-open). */
(function () {
  var BACKEND = "https://soleil-reservation.vercel.app/api/reservations/sync";

  // Durée totale de réservation, en secondes. DOIT correspondre à
  // RESERVATION_TTL_MINUTES côté Vercel (10 min = 600). Si tu changes le TTL,
  // mets cette valeur à jour pour que le dégradé reste calibré.
  var TOTAL_SECONDS = 600;

  var syncing = false, pending = false;
  var expiryMs = null;
  var hasItems = false;

  function injectStyles() {
    if (document.getElementById("sds-hold-styles")) return;
    var css =
      ".sds-hold{display:flex;align-items:center;gap:10px;" +
      "border:1px solid #ECE4BE;border-radius:10px;padding:12px 16px;" +
      "margin:0 0 16px;font-size:14px;line-height:1.3;color:#1A1A1A;" +
      "font-family:inherit;box-sizing:border-box;" +
      "transition:background 2s linear,border-color 2s linear;}" +
      ".sds-hold__icon{flex:0 0 auto;line-height:0;transition:color 2s linear;}" +
      ".sds-hold__label{flex:1 1 auto;min-width:0;letter-spacing:.01em;}" +
      ".sds-hold__time{flex:0 0 auto;color:#1A1A1A;font-weight:600;" +
      "padding:5px 12px;border-radius:999px;font-variant-numeric:tabular-nums;" +
      "letter-spacing:.06em;min-width:50px;text-align:center;white-space:nowrap;" +
      "transition:background 2s linear;}" +
      "@media (max-width:600px){" +
      ".sds-hold{gap:8px;padding:10px 12px;font-size:13px;border-radius:9px;}" +
      ".sds-hold__time{padding:4px 10px;min-width:46px;letter-spacing:.04em;}}" +
      "@media (max-width:380px){.sds-hold__label{font-size:12px;}}";
    var s = document.createElement("style");
    s.id = "sds-hold-styles";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildBanner() {
    var el = document.createElement("div");
    el.className = "sds-hold";
    el.setAttribute("role", "status");
    el.innerHTML =
      '<span class="sds-hold__icon" aria-hidden="true">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" ' +
      'stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle>' +
      '<path d="M12 7v5l3 2"></path></svg></span>' +
      '<span class="sds-hold__label"></span>' +
      '<span class="sds-hold__time"></span>';
    return el;
  }

  var bannerEl = null;

  function findAnchor() {
    var candidates = [
      { sel: "#CartDrawer .drawer__inner", mode: "prepend" },
      { sel: "cart-drawer .drawer__inner", mode: "prepend" },
      { sel: ".cart-drawer .drawer__inner", mode: "prepend" },
      { sel: "#main-cart-items", mode: "before" },
      { sel: ".cart__items", mode: "before" },
      { sel: "cart-items", mode: "prepend" },
      { sel: "#cart", mode: "prepend" }
    ];
    for (var i = 0; i < candidates.length; i++) {
      var node = document.querySelector(candidates[i].sel);
      if (node) return { node: node, mode: candidates[i].mode };
    }
    return null;
  }

  function mountBanner() {
    if (!bannerEl) bannerEl = buildBanner();
    if (bannerEl.isConnected) return;
    var a = findAnchor();
    if (!a) return;
    if (a.mode === "before" && a.node.parentNode) {
      a.node.parentNode.insertBefore(bannerEl, a.node);
    } else {
      a.node.insertBefore(bannerEl, a.node.firstChild);
    }
  }

  function removeBanner() {
    if (bannerEl && bannerEl.isConnected) bannerEl.remove();
  }

  function two(n) { return (n < 10 ? "0" : "") + n; }

  // Couleur en fonction du temps restant.
  // t = 1 (plein temps) -> jaune de marque ; t = 0 (fin) -> corail chaud.
  function applyColor(t) {
    if (!bannerEl) return;
    t = Math.max(0, Math.min(1, t));
    var hue = Math.round(8 + 44 * t);        // 52 (jaune) -> 8 (rouge doux)
    var sat = Math.round(78 + 14 * (1 - t)); // un peu plus saturé vers le rouge
    var light = Math.round(72 + 10 * t);     // 82% (jaune clair) -> 72% (rouge doux)
    bannerEl.style.background = "hsl(" + hue + "," + sat + "%," + light + "%)";
    bannerEl.style.borderColor = "hsl(" + hue + "," + (sat - 10) + "%," + (light - 12) + "%)";
    var pill = bannerEl.querySelector(".sds-hold__time");
    if (pill) pill.style.background = "hsl(" + hue + "," + (sat + 5) + "%," + (light - 5) + "%)";
    var icon = bannerEl.querySelector(".sds-hold__icon");
    if (icon) icon.style.color = "hsl(" + hue + ",55%,28%)";
  }

  function tick() {
    if (!expiryMs || !hasItems) { removeBanner(); return; }
    var remaining = Math.round((expiryMs - Date.now()) / 1000);
    if (remaining <= 0) { removeBanner(); return; }
    mountBanner();
    if (!bannerEl) return;
    var m = Math.floor(remaining / 60), s = remaining % 60;
    var narrow = (window.innerWidth || document.documentElement.clientWidth) <= 480;
    var lbl;
    if (remaining <= 60) lbl = narrow ? "Bientôt terminée" : "Réservation bientôt terminée";
    else lbl = narrow ? "Article réservé" : "Article réservé rien que pour toi";
    bannerEl.querySelector(".sds-hold__label").textContent = lbl;
    bannerEl.querySelector(".sds-hold__time").textContent = two(m) + ":" + two(s);
    applyColor(remaining / TOTAL_SECONDS);
  }

  async function getCart() {
    var r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return r.json();
  }

  async function sync() {
    if (syncing) { pending = true; return; }
    syncing = true;
    try {
      var cart = await getCart();
      var items = (cart.items || []).map(function (i) {
        return { variant_id: String(i.id), quantity: i.quantity };
      });
      hasItems = items.length > 0;
      var resp = await fetch(BACKEND, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify({ token: cart.token, items: items }),
        keepalive: true
      });
      try {
        var data = await resp.json();
        if (data && data.ok && data.expires_at && hasItems) {
          expiryMs = new Date(data.expires_at).getTime();
        } else if (!hasItems) {
          expiryMs = null;
        }
      } catch (e) {}
      tick();
    } catch (e) {}
    syncing = false;
    if (pending) { pending = false; sync(); }
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] instanceof Request ? arguments[0].url : String(arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (isCartMutation(url)) p.then(function () { setTimeout(sync, 150); }).catch(function () {});
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (isCartMutation(String(url))) {
        this.addEventListener("load", function () { setTimeout(sync, 150); });
      }
    } catch (e) {}
    return _open.apply(this, arguments);
  };

  injectStyles();
  setInterval(tick, 1000);
  if (document.readyState !== "loading") sync();
  else document.addEventListener("DOMContentLoaded", sync);
})();